import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { legShape } from 'constants/propTypes';
import { StyledJourneyInfoContainer } from '../Extras.styles';

const ExtrasJourneyInfo = ({ direction }) => (
  <StyledJourneyInfoContainer data-testid="extra-journeys-info">
    <strong>
      <FormattedDate value={direction.timing.isoDate} year="numeric" month="short" day="numeric" weekday="long" />
    </strong>
    <span data-testid="service-departs">{` - ${direction.serviceType.code}${direction.trainNumber} (${direction.timing.departs})`}</span>
    <div data-cy="origin-destination" data-testid="origin-destination">
      {`${direction.origin.name} (${direction.origin.shortCode}) `}
      <FormattedMessage id="extras.to" />
      {` ${direction.destination.name} (${direction.destination.shortCode})`}
    </div>
  </StyledJourneyInfoContainer>
);

ExtrasJourneyInfo.propTypes = {
  direction: legShape
};

export default ExtrasJourneyInfo;
